import { ThemeUIStyleObject } from "theme-ui";

export const iconsColumnWrapStyles: ThemeUIStyleObject = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  px: [2, 6, 13],
  // backgroundColor: "lightGray",
};

export const iconsColumnContainerStyles: ThemeUIStyleObject = {
  width: "100%",
  justifyContent: "center",
};

export const columnItemContainerStyles: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: ["row", "column", "column"],
  textDecoration: "none",
  alignItems: "center",
  mt: [5, 7, 7],
  mb: [5, 7, 7],
};

export const imageWrapStyles: ThemeUIStyleObject = {
  display: "flex",
  justifyContent: "center",
  flex: "none",
  width: "39%",
};

export const ratioStyles: ThemeUIStyleObject = {
  flex: ["1 0 85px", "1 0 175px"],
  mb: [0, 5, 5],
  borderRadius: "50%",
  overflow: "hidden",
  position: "relative",
  bg: "darkGreen",
  "&:after": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "1",
    width: "80%",
    height: "80%",
    borderRadius: "50%",
    border: "3px solid rgba(255, 255, 255, 0.3)",
    transform: "translate(-50%, -50%)",
    transition: "border 0.3s",
  },
  "a:hover &, a:focus &": {
    "&:after": {
      borderColor: "white",
    },
  },
};
export const imageStyles: ThemeUIStyleObject = {
  width: "100%",
};

export const columnItemContentStyles: ThemeUIStyleObject = {
  display: "block",
  margin: ["auto 0", "auto"],
  pl: [4, 0, 0],
  maxWidth: [null, "200px"],
  textAlign: ["left", "center", "center"],
};

export const headingStyles: ThemeUIStyleObject = {
  mb: 0,
  color: "darkGreen",
  lineHeight: "tight",
  fontSize: ["paragraphMedium", "h5"],
};

export const descriptionStyles: ThemeUIStyleObject = {
  mt: [3, 5],
  mb: 0,
  fontSize: ["paragraphSmall", "paragraphMedium"],
  "& p": {
    mt: [3, 5],
    mb: 0,
    fontSize: ["paragraphSmall", "paragraphMedium"],
  },
};
